export const CategoryColumnName = 'rowHeader';
export const PSEUDO_FULL_RESPONSE = 9999;
